function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import stringify from 'json-stable-stringify';
import { useCallback, useEffect, useRef, useState } from 'react';
import { get, post } from "../fetch";
var DEFAULT_PAGE_SIZE = 20;
export function useList(options) {
  var _initPageRef$current, _page$sorts;
  var _options$auto = options.auto,
    auto = _options$auto === void 0 ? true : _options$auto,
    _options$method = options.method,
    method = _options$method === void 0 ? 'get' : _options$method,
    url = options.url,
    initialPage = options.initialPage,
    initialQuery = options.initialQuery,
    requestFilter = options.requestFilter,
    responseFilter = options.responseFilter,
    responseCustomize = options.responseCustomize,
    _options$showTooltips = options.showTooltips,
    showTooltips = _options$showTooltips === void 0 ? true : _options$showTooltips;
  var autoloadedRef = useRef(false);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var queryTimes = useRef(0);
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    total = _useState4[0],
    setTotal = _useState4[1];
  var initPageRef = useRef(initialPage);
  var initQueryRef = useRef(initialQuery);
  var _useState5 = useState(createPage(initPageRef.current)),
    _useState6 = _slicedToArray(_useState5, 2),
    page = _useState6[0],
    setPage = _useState6[1];
  var pullDownRef = useRef(false);
  var forceRefreshRef = useRef(false);
  var delayRefreshRef = useRef(false);
  var _useState7 = useState(createQuery(initQueryRef.current)),
    _useState8 = _slicedToArray(_useState7, 2),
    query = _useState8[0],
    setQuery = _useState8[1];
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    data = _useState10[0],
    setData = _useState10[1];
  var _useState11 = useState(),
    _useState12 = _slicedToArray(_useState11, 2),
    error = _useState12[0],
    setError = _useState12[1];
  var pageSize = Number(page.size || ((_initPageRef$current = initPageRef.current) === null || _initPageRef$current === void 0 ? void 0 : _initPageRef$current.size) || DEFAULT_PAGE_SIZE);
  var totalPage = Math.ceil(total / pageSize);
  var complete = !loading && (page.index === totalPage || totalPage === 0);
  var isEmpty = !loading && data.length === 0 && queryTimes.current !== 0;
  var handlePageReset = useCallback(function (opts) {
    var _ref = opts || {},
      delayRefresh = _ref.delayRefresh;
    if (forceRefreshRef.current) {
      setData([]);
    }
    if (delayRefresh) {
      delayRefreshRef.current = true;
    } else {
      setData([]);
    }
    setLoading(false);
    setTotal(0);
    setPage(function (curPage) {
      var nextPage = createPage(_objectSpread(_objectSpread({}, initPageRef.current), {}, {
        sorts: curPage.sorts
      }));
      return nextPage;
    });
  }, []);
  var handleReset = useCallback(function () {
    var nextPage = createPage(initPageRef.current);
    var nextQuery = createQuery(initQueryRef.current);
    forceRefreshRef.current = true;
    setLoading(false);
    setTotal(0);
    setData([]);
    setPage(nextPage);
    setQuery(nextQuery);
  }, []);
  var handleReload = useCallback(function () {
    forceRefreshRef.current = true;
    handlePageReset();
  }, [handlePageReset]);
  var handleSort = useCallback(function (sorts) {
    var prevSorts = page.sorts;
    // diff
    var changed = (prevSorts === null || prevSorts === void 0 ? void 0 : prevSorts.length) !== sorts.length || sorts.some(function (sort) {
      var matched = prevSorts.find(function (s) {
        return s.field === sort.field;
      });
      if (!matched) {
        return true;
      }
      return matched.direction !== sort.direction;
    });
    if (changed) {
      setPage(function (curPage) {
        return _objectSpread(_objectSpread({}, curPage), {}, {
          sorts: sorts
        });
      });
      handlePageReset();
    }
  }, [page, handlePageReset]);
  var handleQuery = useCallback(function () {
    var nextQuery = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // diff
    // console.log('query1', query)
    // console.log('nextQuery1', nextQuery)
    var changed = stringify(query) !== stringify(nextQuery);
    if (changed) {
      setQuery(nextQuery);
      handlePageReset();
    }
  }, [query, handlePageReset]);
  var handleNext = useCallback(function () {
    setPage(function (curPage) {
      // page++
      var curIndex = Number(curPage.index || 1);
      var nextIndex = curIndex + 1;
      if (nextIndex > totalPage) {
        return curPage;
      }
      return _objectSpread(_objectSpread({}, curPage), {}, {
        index: nextIndex
      });
    });
  }, [totalPage]);
  var handleRequest = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var curTime, delayClear, searchQuery, _requestFilter, nextPage, nextQuery, res, customRes, _customRes, nextListData, _res, _res$page, _nextPage, listData, nextTotal, _nextListData, nextPageNum;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!loading) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            curTime = queryTimes.current = queryTimes.current + 1;
            delayClear = delayRefreshRef.current;
            searchQuery = _objectSpread({
              page: page
            }, query);
            if (requestFilter) {
              _requestFilter = requestFilter(page, query), nextPage = _requestFilter.page, nextQuery = _requestFilter.query;
              searchQuery = _objectSpread({
                page: nextPage
              }, nextQuery);
            }
            setLoading(true);
            setError(undefined);
            _context.prev = 8;
            // 请求
            if (delayClear) {
              setData([]);
            }
            _context.next = 12;
            return queryList(method, url, searchQuery);
          case 12:
            res = _context.sent;
            if (responseFilter) {
              res = responseFilter(res);
            }
            if (responseCustomize) {
              customRes = responseCustomize(res);
            }
            console.log('curTime', {
              curTime: curTime,
              'queryTimes.current': queryTimes.current
            });
            if (curTime === queryTimes.current) {
              if (responseCustomize && customRes) {
                _customRes = customRes, nextListData = _customRes.data;
                setData(nextListData);
              } else {
                _res = res, _res$page = _res.page, _nextPage = _res$page === void 0 ? {} : _res$page, listData = _res.data, nextTotal = _res.totalCount;
                _nextListData = listData;
                nextPageNum = Number(_nextPage.index = (_nextPage === null || _nextPage === void 0 ? void 0 : _nextPage.index) || 1);
                setData(function (curData) {
                  var startIndex = (nextPageNum - 1) * pageSize;
                  var nextData = delayClear ? [] : _toConsumableArray(curData);
                  nextData.splice.apply(nextData, [startIndex, pageSize].concat(_toConsumableArray(_nextListData)));
                  return nextData;
                });
                // page 修正
                setPage(function (curPage) {
                  var changed = curPage.index !== _nextPage.index || curPage.size !== _nextPage.size;
                  if (changed) {
                    return _objectSpread(_objectSpread({}, _nextPage), {}, {
                      sorts: curPage.sorts
                    });
                  }
                  return curPage;
                });
                /** 暂时停止 sorts 修正 */
                /* if (nextPage.sorts) {
                  handleSort(nextPage.sorts)
                } */
                setTotal(nextTotal || 0);
              }
            }
            _context.next = 25;
            break;
          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](8);
            console.error(_context.t0);
            if (curTime === queryTimes.current && showTooltips) {
              // Taro.showToast({
              //   title: '列表查询失败',
              //   icon: 'none',
              // })
            }
            handlePageReset();
            setError(_context.t0);
          case 25:
            _context.prev = 25;
            pullDownRef.current = false;
            forceRefreshRef.current = false;
            delayRefreshRef.current = false;
            setLoading(false);
            return _context.finish(25);
          case 31:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[8, 19, 25, 31]]);
    }));
    return function handleRequest() {
      return _ref2.apply(this, arguments);
    };
  }();
  var prevSnap = useRef();
  useEffect(function () {
    if (!url) {
      return;
    }
    var curSnap = stringify({
      method: method,
      page: page,
      pageSize: pageSize,
      query: query,
      url: url
    });
    var shouldRequest = false;
    if (prevSnap.current !== curSnap) {
      prevSnap.current = curSnap;
      shouldRequest = true;
    }
    if (pullDownRef.current || forceRefreshRef.current) {
      shouldRequest = true;
    }
    if (!autoloadedRef.current) {
      autoloadedRef.current = true;
      shouldRequest = Boolean(auto);
    }
    if (shouldRequest) {
      handleRequest();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleRequest, method, url, page, query, requestFilter, responseFilter]);
  var isPullDownRefreshing = loading && pullDownRef.current;
  var scrollProps = {
    hasMore: !complete,
    onRefresherRefresh: function onRefresherRefresh() {
      pullDownRef.current = true;
      handlePageReset({
        delayRefresh: true
      });
    },
    next: handleNext
  };
  return {
    loading: loading,
    query: query,
    page: page,
    sort: (_page$sorts = page.sorts) === null || _page$sorts === void 0 ? void 0 : _page$sorts[0],
    totalPage: totalPage,
    data: data,
    error: error,
    complete: complete,
    isEmpty: isEmpty,
    handleReset: handleReset,
    handleReload: handleReload,
    handleSort: handleSort,
    handleQuery: handleQuery,
    handleNext: handleNext,
    handleRequest: handleRequest,
    scrollProps: scrollProps
  };
}
function queryList(_x, _x2, _x3) {
  return _queryList.apply(this, arguments);
}
function _queryList() {
  _queryList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(method, url, query) {
    var request, _yield$request, code, data, msg;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          request = "".concat(method || '').toLowerCase() === 'post' ? post : get;
          _context2.next = 3;
          return request({
            url: url,
            query: query
          });
        case 3:
          _yield$request = _context2.sent;
          code = _yield$request.code;
          data = _yield$request.data;
          msg = _yield$request.msg;
          if (!(code === 0)) {
            _context2.next = 9;
            break;
          }
          return _context2.abrupt("return", data);
        case 9:
          throw new Error(msg || "\u5F02\u5E38(".concat(code, ")"));
        case 10:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _queryList.apply(this, arguments);
}
export default useList;
export var SortDirMap = {
  /** 升序(ASC), 从小到大 */
  ascend: 'ASC',
  /** 降序(DESC), 从大到小 */
  descend: 'DESC'
};
function createPage(page) {
  return _objectSpread({
    size: DEFAULT_PAGE_SIZE,
    index: 1,
    sorts: []
  }, page);
}
function createQuery(initialQuery) {
  return _objectSpread({}, initialQuery);
}
export function createSort(field) {
  var dir = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SortDirMap['descend'];
  return {
    field: field,
    direction: dir
  };
}
export function toggleSort(sort) {
  var nextDir = sort.direction === SortDirMap['ascend'] ? SortDirMap['descend'] : SortDirMap['ascend'];
  return _objectSpread(_objectSpread({}, sort), {}, {
    direction: nextDir
  });
}
function isEmptyOrNil(val) {
  if (val == null) {
    return true;
  }
  if (Array.isArray(val) && val.length === 0) {
    return true;
  }
  if (_typeof(val) === 'object' && Object.keys(val).length === 0) {
    return true;
  }
  return false;
}
export function isQueryEmpty(query) {
  for (var key in query) {
    if (Object.prototype.hasOwnProperty.call(query, key)) {
      var val = query[key];
      if (!isEmptyOrNil(val)) {
        return false;
      }
    }
  }
  return true;
}